// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginPage_login__rGtyx {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--gutter);
  gap: calc(var(--gutter) * var(--golden-ratio));
  height: 100vh;
}
.LoginPage_login__header__liVcO {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(var(--gutter) / var(--golden-ratio));
}
.LoginPage_login__header__liVcO svg {
  width: auto;
  height: 80px;
}
.LoginPage_login__wordmark__yrLXt {
  font-size: calc(var(--font-size-base) * 4);
  line-height: calc(var(--font-size-base) * 4);
  text-transform: uppercase;
  color: var(--color-text);
  font-weight: 900;
  display: flex;
  gap: calc(var(--gutter) / var(--golden-ratio));
}
.LoginPage_login__wordmark__yrLXt span {
  font-style: italic;
}
.LoginPage_login__text__8yKYu {
  color: var(--color-text-subtle);
}`, "",{"version":3,"sources":["webpack://./src/views/LoginPage.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,8CAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8CAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AAGE;EACE,0CAAA;EACA,4CAAA;EACA,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,8CAAA;AADJ;AAGI;EACE,kBAAA;AADN;AAKE;EACE,+BAAA;AAHJ","sourcesContent":[".login {\n  display: flex; \n  flex-direction: column; \n  align-items: center; \n  justify-content: center;\n  padding: var(--gutter);\n  gap: calc(var(--gutter) * var(--golden-ratio));\n  height: 100vh;\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: calc(var(--gutter) / var(--golden-ratio));\n\n    svg {\n      width: auto;\n      height: 80px;\n    }\n  }\n\n  &__wordmark {\n    font-size: calc(var(--font-size-base) * 4);\n    line-height: calc(var(--font-size-base) * 4);\n    text-transform: uppercase;\n    color: var(--color-text);\n    font-weight: 900;\n    display: flex;\n    gap: calc(var(--gutter) / var(--golden-ratio));\n\n    span {\n      font-style: italic;\n    }\n  }\n\n  &__text {\n    color: var(--color-text-subtle);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login": `LoginPage_login__rGtyx`,
	"login__header": `LoginPage_login__header__liVcO`,
	"login__wordmark": `LoginPage_login__wordmark__yrLXt`,
	"login__text": `LoginPage_login__text__8yKYu`
};
export default ___CSS_LOADER_EXPORT___;
